import Model from './Model';

export default class ExaminationBoardModel extends Model {
  id: number;
  title: string;

  static __typename: string = "ExaminationBoard";

  constructor(examinationBoard: any, getters: any) {
    super(getters);
    this.id = examinationBoard.id;
    this.title = examinationBoard.title;
  }

  raw() {
    return {
      id: this.id,
      title: this.title,
      __typename: ExaminationBoardModel.__typename
    }
  }
}